import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import BookingsPage from './components/BookingsPage';
import ChatPage from './components/ChatPage';
import { initialBookings, initialChats } from './data/mockData';
import useApi from './data/mockData';
import LoginPage from './components/LoginPage';
import axios from 'axios';
export default function App() {
  const [activeTab, setActiveTab] = useState('bookings');
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 1024);
  const [bookings, setBookings] = useState(initialBookings);

  const toggleSidebar = useCallback(() => {
    setSidebarOpen(prev => !prev);
  }, []);

  const handelBookings = ()=>{
     axios.get("https://dr-mohamed-khaled.site/api/patients")
     .then((res)=>{
      setBookings(res?.data?.patients || []);
      console.log(res?.data?.patients);
     })
     .catch((err)=>{
      console.log(err);
     })
  }
  // Handle window resize
  useEffect(() => {
    handelBookings()
    const handleResize = () => {
      const isDesktop = window.innerWidth >= 1024;
      setSidebarOpen(prev => {
        // On desktop, always open. On mobile, keep current state unless switching to desktop
        if (isDesktop) return true;
        return prev;
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDelete = (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الحجز؟')) {
      setBookings(prev => prev.filter(b => b.id !== id));
    }
  };

  const handleEdit = (id, updated) => {
    setBookings(prev => prev.map(b => b.id === id ? { ...b, ...updated } : b));
  };

const [totalUnread, setTotalUnread] = useState(0);

useEffect(()=>{
axios.get("https://dr-mohamed-khaled.site/api/chat/rooms")
.then((res)=>{
  setTotalUnread(res?.data?.count || 0);
})
.catch((err)=>{
  console.log(err);
})
}, [])

  return (
    <div className="app">
      {
        localStorage.getItem('token') ? <>
        <useApi />
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        bookingsCount={bookings.length}
        chatsCount={totalUnread}
      />

      <main className={`main-content ${sidebarOpen ? '' : 'full'}`}>
        <TopBar activeTab={activeTab} />
        <div className="content-area">
          {activeTab === 'bookings' 
            ? <BookingsPage bookings={bookings} onDelete={handleDelete} onEdit={handleEdit} />
            : <ChatPage />
          }
        </div>
      </main>
        </> : <LoginPage />
      }
   
    </div>
  );
}
